export function register() {
  console.log("Registrando service worker", navigator)
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const swUrl = `${window.location.origin}/service-worker.js`;

      sessionStorage.removeItem('sw-reload');
      let hadController = !!navigator.serviceWorker.controller;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!hadController) {
          hadController = true;
          return;
        }
        if (sessionStorage.getItem('sw-reload') === '1') return;
        sessionStorage.setItem('sw-reload', '1');
        window.location.reload();
      });

      navigator.serviceWorker.register(swUrl, { updateViaCache: "none" })
        .then((registration) => {
          console.log('Service worker registrado com sucesso!', registration);
          const checkUpdate = () => {
            registration.update().catch(() => undefined);
          };
          document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') checkUpdate();
          });
          window.addEventListener('focus', checkUpdate);
          
          // Agregar manejo de errores más robusto
          registration.addEventListener('error', (event) => {
            console.warn('Service Worker error:', event);
          });
          
          registration.addEventListener('message', (event) => {
            console.log('Service Worker message:', event.data);
            
            // ✅ MEJORADO: Responder inmediatamente para evitar errores de canal
            try {
              if (event.ports && event.ports.length > 0) {
                event.ports.forEach(port => {
                  try {
                    port.postMessage({ type: 'ACK', received: true });
                  } catch (portError) {
                    console.warn('Service Worker registration: Error enviando ACK:', portError);
                  }
                });
              }
            } catch (error) {
              console.warn('Service Worker registration: Error en manejo de mensajes:', error);
            }
          });
        })
        .catch((error) => {
          console.error('Erro durante o registro do service worker:', error);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('Erro durante o desregistro do service worker:', error);
      });
  }
}
